import { useDispatch } from "react-redux";
import "./SidebarTabsContent.scss";
import { setGradientValueAC } from "store/actions/colorSidebar";

const GradientColorContent = ({ gradientData }) => {
  const dispatch = useDispatch();

  const setFirstValueHandler = (event) => {
    dispatch(
      setGradientValueAC({
        firstValue: event.currentTarget.value,
      })
    );
  };

  const setSecondValueHandler = (event) => {
    dispatch(
      setGradientValueAC({
        secondValue: event.currentTarget.value,
      })
    );
  };

  return (
    <div className="color-content">
      <div className="gradient-wrapper">
        <div className="gradient-item-inner">
          <span className="gradient-item_title">Minimum</span>
          <input
            onChange={setFirstValueHandler}
            className="gradient-item_color-picker"
            value={gradientData.firstValue}
            type="color"
          />
        </div>

        <div className="gradient-item_border"></div>

        <div className="gradient-item-inner">
          <span className="gradient-item_title">Maximum</span>
          <input
            onChange={setSecondValueHandler}
            className="gradient-item_color-picker"
            value={gradientData.secondValue}
            type="color"
          />
        </div>
      </div>
    </div>
  );
};

export default GradientColorContent;
